// Settings tab shown for draft sessions: edit or cancel the class
import { Pencil, Trash2 } from 'lucide-react'

import { Card, CardContent } from '@/ui/card'
import { Button } from '@/ui/button'

interface SessionSettingsTabProps {
  onEdit: () => void
  onCancel: () => void
  loading?: boolean
}

export function SessionSettingsTab({ onEdit, onCancel, loading }: SessionSettingsTabProps) {
  return (
    <Card className="border-red-200">
      <CardContent className="p-4 space-y-4">
        <div>
          <p className="text-sm font-medium text-navy">Class Settings</p>
          <p className="text-xs text-slate-500">Manage or remove this scheduled class.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={onEdit} disabled={loading}>
            <Pencil className="w-4 h-4" />
            Edit Class
          </Button>
          <Button variant="destructive" onClick={onCancel} disabled={loading}>
            <Trash2 className="w-4 h-4" />
            Cancel Class
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
